import { combineReducers } from "redux"
import newChats from "./chat"

const chatReducer = combineReducers({
  newChats
})

export default chatReducer